import { Middleware } from '@reduxjs/toolkit';
import { baseApi } from '../../services/base-api';
import { setCurrentRoute } from '../slices/global.slice';

/**
 * Middleware that resets page-specific state when navigating between routes
 * Prevents stale data from persisting when switching pages
 */
const routeResetMiddleware: Middleware<{}, any, any> = store => next => action => {
  if (setCurrentRoute.match(action)) {
    const currentRoute = store.getState().global.currentRoute;
    const newRoute = action.payload;

    if (currentRoute !== newRoute) {
      if (currentRoute.startsWith('/brands') && !newRoute.startsWith('/brands')) {
        store.dispatch(baseApi.util.invalidateTags(['BrandsList']));
      }
      // if (currentRoute.startsWith('/orders') && !newRoute.startsWith('/orders')) {
      //   store.dispatch(resetOrdersState());
      // }
      if (currentRoute.startsWith('/azk-list') && !newRoute.startsWith('/azk-list')) {
        store.dispatch(baseApi.util.invalidateTags(['AzkList', 'StationProfile']));
      }
      if (currentRoute.startsWith('/user-management') && !newRoute.startsWith('/user-management')) {
        store.dispatch(baseApi.util.invalidateTags(['UsersList', 'SalesExpertsList']));
      }
      // if (currentRoute.startsWith('/upload') && !newRoute.startsWith('/upload')) {
      //   store.dispatch(resetUploadState());
      // }
      if (currentRoute.startsWith('/azk-binding') && !newRoute.startsWith('/azk-binding')) {
        store.dispatch(baseApi.util.invalidateTags(['AzkOkkoStations', 'AzkCompetitorStations', 'AzkBindings', 'AzkFormOptions', 'AzkCompetitorFilters']));
      }
      if (currentRoute.startsWith('/price-processing') && !newRoute.startsWith('/price-processing')) {
        store.dispatch(baseApi.util.invalidateTags(['PriceProcessingFilters', 'PriceProcessingData']));
      }
      if (currentRoute.startsWith('/orders') && !newRoute.startsWith('/orders')) {
        store.dispatch(baseApi.util.invalidateTags(['Orders', 'OrdersFilters', 'OrdersHistory']));
      }
      if (currentRoute.startsWith('/scheduler') && !newRoute.startsWith('/scheduler')) {
        store.dispatch(baseApi.util.invalidateTags(['SchedulerEntries']));
      }
      // RTK Query pages: invalidate cache tags so data is refetched fresh on return
      if (currentRoute.startsWith('/pricing-regional') && !newRoute.startsWith('/pricing-regional')) {
        store.dispatch(baseApi.util.invalidateTags(['BrandOrder', 'Summary', 'RegionalSummary']));
      }
      if (currentRoute.startsWith('/pricing-province') && !newRoute.startsWith('/pricing-province')) {
        store.dispatch(baseApi.util.invalidateTags(['BrandOrder', 'ProvinceSummary', 'ProvinceOverallSummary']));
      }
      if (currentRoute.startsWith('/price-comparison') && !newRoute.startsWith('/price-comparison')) {
        store.dispatch(baseApi.util.invalidateTags(['ProceComparissonFilters']));
      }
    }
  }

  return next(action);
};

export default routeResetMiddleware;
